/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Link as WsLink } from '@mui/material';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { styled } from '@mui/styles';
import React from 'react';

import ILoginParams from '../../types/ILoginParams';
import WsColors from '../../WsColors';

const Link = styled('div')(() => ({
  color: WsColors.TheBlues950,
  cursor: 'pointer',
  display: 'inline',
}));
interface ILoginAlert {
  loginParam: ILoginParams;
  statusCode: number;
  bearerToken: string | null;
  resendEmail(args: string): void;
  overRideToken(args: ILoginParams): void;
  activateMFA(args: string): void;
}

const LoginAlert: React.FC<ILoginAlert> = ({
  loginParam,
  statusCode,
  bearerToken,
  resendEmail,
  overRideToken,
  activateMFA,
}) => {
  let errorElement = (
    <Alert severity="error">Failed to sign in! Please check your credentials and try again.</Alert>
  );
  switch (statusCode) {
    case 400:
      errorElement = (
        <Alert severity="error">
          <AlertTitle>
            You are not part of this workspace,
            <Link onClick={() => (window.location.href = 'https://recruitment.wisestep.com')}>
              &nbsp;click here&nbsp;
            </Link>
            to log in to your workspace
          </AlertTitle>
        </Alert>
      );
      break;
    case 403:
      errorElement = (
        <Alert severity="error">
          <AlertTitle>Failed to sign in!</AlertTitle>
          You signed up but your Account is not activated. We sent you an email with the Activation
          code to Activate your Account. Didn't receive?
          <Link onClick={() => resendEmail(loginParam.username)}>Resend activation link.</Link>
        </Alert>
      );
      break;
    case 409:
      errorElement = (
        <Alert severity="warning">
          <AlertTitle>Another user is already Signed in!</AlertTitle>
          <Link onClick={() => overRideToken(loginParam)}>Click</Link>
          &nbsp;to log the other user out.
        </Alert>
      );
      break;
    case 404:
      errorElement = <Alert severity="error">Email not registered yet.</Alert>;
      break;
    case 423:
      errorElement = (
        <Alert severity="error">
          <AlertTitle>Failed to sign in!</AlertTitle>
          You signed up but your Account is deactivated.
        </Alert>
      );
      break;
    case 412:
      if (process.env.REACT_APP_URL) {
        window.location.reload();
      }
      break;
    case 500:
      errorElement = (
        <Alert severity="error">
          <AlertTitle>Failed to sign in!</AlertTitle>
          Unknown error from server. Please try after some time.
        </Alert>
      );
      break;
    case 428:
      errorElement = <></>;
      if (bearerToken) {
        activateMFA(bearerToken);
      }
      break;
    case 44444:
      errorElement = (
        <Alert severity="error">
          <AlertTitle>You account is temporarly blocked due to malecious activity</AlertTitle>
          Please contact
          <WsLink sx={{ fontSize: 16, ml: 0.6, mr: 0.6 }} href="mailto:support@wisestepmail.com">
            support@wisestepmail.com
          </WsLink>
          to reactivate
        </Alert>
      );
      break;
  }
  return errorElement;
};
export default LoginAlert;
